import {
  getUserType,
  PatientType,
} from "src/funnels/insurance-reimbursement/apiRequests";
import { useQuery } from "react-query";
import {
  getNoomSessionStorage,
  setNoomSessionStorage,
} from "@utils/noomSessionStorage";
import { SessionStorageKey } from "@utils/constants";
import getStore from "@utils/redux/store";

// NOTE: It is not possible to use get/setSessionState("browser") as the
// emitted events functionality causes a React error.
// Ensure we use session storage so that the patient type can be logged
// elsewhere such as to mixpanel
export const getUserTypeWithSessionStorage = async (): Promise<PatientType> => {
  const { user_id } = getStore().getState().serverContext;
  if (!user_id) {
    return null;
  }
  const storedPatientType = getNoomSessionStorage(
    SessionStorageKey.patientType
  );
  if (storedPatientType) {
    return storedPatientType;
  }
  const { patientType } = await getUserType(user_id).catch(() => {
    return { patientType: null };
  });
  setNoomSessionStorage(SessionStorageKey.patientType, patientType);
  return patientType;
};

export const usePatientType = () => {
  return useQuery("patientType", () => getUserTypeWithSessionStorage());
};
